import { NavigationTabsLine } from 'Components/lines/navigation-tabs-line/NavigationTabsLine';
export default NavigationTabsLine;
